import { createClient } from '@supabase/supabase-js'

const supabaseUrl  = import.meta.env.VITE_SUPABASE_URL
const supabaseAnon = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnon) {
  throw new Error(
    'Missing Supabase env vars. Copy .env.local.example → .env.local and fill in your project values.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    autoRefreshToken:    true,
    persistSession:      true,
    detectSessionInUrl:  true,         // let Supabase auto-exchange PKCE code
    storageKey:          'siglat-auth',
    flowType:            'pkce',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

export default supabase
